import { matchType, substituteCharacters } from './utils';
function prioritizeMatchTypes(by, left, right) {
  const leftMatches = left === by;
  const rightMatches = right === by;
  if (leftMatches && rightMatches) {
    return 'both';
  }
  if (leftMatches) {
    return -1;
  }
  if (rightMatches) {
    return 1;
  }
  return 0;
}
function compareMatchTypes(left, right) {
  if (left !== right) {
    if (left === 'exact') {
      return -1;
    }
    if (right === 'exact') {
      return 1;
    }
  }
  if (left === 'none' && right === 'none') {
    return 0;
  }
  if (left === 'none') {
    return 1;
  }
  if (right === 'none') {
    return -1;
  }
  function priorityBy(matchType) {
    return prioritizeMatchTypes(matchType, left, right);
  }
  const wordFromBeginningPriority = priorityBy('word from beginning');
  if (wordFromBeginningPriority !== 0) {
    return wordFromBeginningPriority;
  }
  const wordPriority = priorityBy('word');
  if (wordPriority !== 0) {
    return wordPriority;
  }
  const substringFromBeginningPriority = priorityBy('substring from beginning');
  if (substringFromBeginningPriority !== 0) {
    return substringFromBeginningPriority;
  }
  const substringPriority = priorityBy('substring');
  if (substringPriority !== 0) {
    return substringPriority;
  }
  return 0;
}
function alphabeticallyByTitle(left, right) {
  const result = left.title.toLowerCase().localeCompare(right.title.toLowerCase());
  if (result < 0) {
    return -1;
  }
  if (result > 0) {
    return 1;
  }
  return 0;
}
function mostExactMatchTypeOf(words, query) {
  return words.reduce((mostExactType, str) => {
    const currentMatchType = matchType(str, query);
    const result = compareMatchTypes(mostExactType, currentMatchType);
    if (result === 1) {
      return currentMatchType;
    }
    return mostExactType;
  }, 'none');
}
export function compareSubcategories(left, right, unsubstitutedQuery) {
  function alphabetically() {
    return alphabeticallyByTitle(left, right);
  }
  if (unsubstitutedQuery === '') {
    return alphabetically();
  }
  const query = substituteCharacters(unsubstitutedQuery);
  const leftLowerCaseTitle = left.title.toLowerCase();
  const rightLowerCaseTitle = right.title.toLowerCase();
  const leftTitleMatchType = matchType(leftLowerCaseTitle, query);
  const rightTitleMatchType = matchType(rightLowerCaseTitle, query);
  const titlePriority = compareMatchTypes(leftTitleMatchType, rightTitleMatchType);
  if (titlePriority === 'both') {
    return alphabetically();
  }
  if (titlePriority !== 0) {
    return titlePriority;
  }
  const leftSynonymMatchType = mostExactMatchTypeOf(left.synonyms, query);
  const rightSynonymMatchType = mostExactMatchTypeOf(right.synonyms, query);
  const synonymPriority = compareMatchTypes(leftSynonymMatchType, rightSynonymMatchType);
  if (synonymPriority === 'both') {
    return alphabetically();
  }
  if (synonymPriority !== 0) {
    return synonymPriority;
  }
  if (left.account.folio !== right.account.folio) {
    const leftAccountCode = left.account.folio.toString();
    const rightAccountCode = right.account.folio.toString();
    if (leftAccountCode === query) {
      return -1;
    }
    if (rightAccountCode === query) {
      return 1;
    }
  }
  const leftAccountNameMatchType = matchType(left.account.name, query);
  const rightAccountNameMatchType = matchType(right.account.name, query);
  const accountNamePriority = compareMatchTypes(leftAccountNameMatchType, rightAccountNameMatchType);
  if (accountNamePriority === 'both') {
    return alphabetically();
  }
  if (accountNamePriority !== 0) {
    return accountNamePriority;
  }
  return alphabetically();
}
//# sourceMappingURL=sorting-utils.js.map